import { Card } from '@procurify/ui'
import styled from 'styled-components'

export const ConversationOrderSummaryCardStyled = styled(Card)`
  && {
    width: 100%;
    background: ${(props) => props.theme.colors.content.mainBackground};
    box-shadow: none;
  }
`
